import { render, staticRenderFns } from "./CargoBusClsList.vue?vue&type=template&id=52c02634&"
import script from "./CargoBusClsList.vue?vue&type=script&lang=js&"
export * from "./CargoBusClsList.vue?vue&type=script&lang=js&"
import style0 from "./CargoBusClsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoBusClsList.vue"
export default component.exports